import {
  MdArrowRight,
  MdDeleteOutline,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineVisibility,
} from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';
import * as SelectPrimitive from '@radix-ui/react-select';

export const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  width: 100%;
  border: 1px solid ${colors.inputBorderLight};

  & > button {
    min-width: 15rem;
  }
`;

export const Fieldset = styled.fieldset`
  all: unset;
  align-items: center;
  background-color: ${colors.white300};
  border-radius: ${radii.px};
  border: 1px solid ${colors.inputBorderLight};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;

  &:focus-within {
    border: 1px solid ${colors.fieldFocus};
  }
`;

export const Input = styled.input`
  background-color: ${colors.white300};
  border-radius: ${radii.sm};
  border: none;
  color: ${colors.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 2rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  z-index: 1;

  &::placeholder {
    color: ${colors.inputPlaceholder};
  }
`;

export const ArrowUpContainer = styled(SelectPrimitive.ScrollUpButton)`
  align-items: center;
  background-color: ${colors.white300};
  color: ${colors.blue300};
  cursor: default;
  display: flex;
  height: 1.625rem;
  justify-content: center;

  &:hover {
    background-color: ${colors.backgroundHover};
  }
`;

export const ArrowUp = styled(MdKeyboardArrowUp)`
  height: 1rem;
  width: 1rem;
`;

export const Viewport = styled(SelectPrimitive.Viewport)`
  padding: 0.315rem;
`;

export const ItemContainer = styled.div`
  align-items: center;
  display: flex;
  border-radius: ${radii.sm};
  background-color: ${colors.white300};

  &:hover {
    background-color: ${colors.backgroundHover};
  }

  &:focus-within {
    background-color: ${colors.backgroundHover};
  }
`;

export const Item = styled(SelectPrimitive.Item)`
  all: unset;
  align-items: center;
  color: ${colors.text};
  display: flex;
  flex-grow: 1;
  height: 100%;
  font-size: 1rem;
  line-height: 1.1;
  padding: 0.375rem 0.375rem 0.375rem 1.5rem;
  position: relative;
  user-select: none;

  &[data-disabled] {
    color: ${colors.gray200};
    pointer-events: none;
  }
`;

export const IndicatorContainer = styled(SelectPrimitive.SelectItemIndicator)`
  align-items: center;
  color: ${colors.blue300};
  display: inline-flex;
  justify-content: center;
  left: 0px;
  position: absolute;
  width: 25px;
`;

export const SelectIcon = styled(MdArrowRight)`
  height: 1.125rem;
  width: 1.125rem;
`;

export const ArrowDownContainer = styled(SelectPrimitive.ScrollDownButton)`
  align-items: center;
  background-color: ${colors.white300};
  color: ${colors.blue300};
  cursor: default;
  display: flex;
  height: 25px;
  justify-content: center;

  &:hover {
    background-color: ${colors.backgroundHover};
  }
`;

export const ArrowDown = styled(MdKeyboardArrowDown)`
  height: 1rem;
  width: 1rem;
`;

export const ActionButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

export const PreviewLink = styled(Link)`
  all: unset;
  align-items: center;
  border-radius: ${radii.full};
  color: ${colors.blue400};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  height: 2.25rem;
  justify-content: center;
  margin: 0.25rem;
  width: 2.25rem;

  &:hover {
    background-color: ${colors.backgroundHover};
  }
`;

export const ActionButton = styled.button`
  all: unset;
  align-items: center;
  border-radius: ${radii.full};
  color: ${colors.blue400};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  height: 2.25rem;
  justify-content: center;
  margin: 0.25rem;
  width: 2.25rem;

  &:disabled {
    opacity: 0.2;
  }

  &:hover {
    background-color: ${colors.backgroundHover};
  }
`;

export const PreviewIcon = styled(MdOutlineVisibility)`
  height: 1.5rem;
  width: 1.5rem;
`;

export const DeleteIcon = styled(MdDeleteOutline)`
  height: 1.5rem;
  width: 1.5rem;
`;
export const NoTemplateContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

export const NoTemplateText = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: ${colors.textLight};
`;
